import React from 'react'
import { useTranslation } from 'react-i18next'
import { Steps } from '../../../ui/Steps/Steps'
import { Step } from '../../../ui/Steps/Step/Step'

/**
 * @param {number} currentStep
 * @param {{name: string, id: number, tier: number}[]} tierSteps
 * @param {(Object[])[]} fieldsBySteps
 */
const BlockWithSteps = ({
  currentStep,
  tierSteps,
  fieldsBySteps
}) => {
  const { i18n } = useTranslation()
  return (
    <Steps step={currentStep}>
      {tierSteps.map((step, index) => (
        <Step
          title={step.i18n[i18n.language] || step.i18n.en}
          key={`${index}-${step.name}`}
          index={index}
          isCurrent={currentStep === index}
        >
          {fieldsBySteps[index]}
        </Step>
      ))}
    </Steps>
  )
}

export { BlockWithSteps }
